<template>
    <div class="pizarra">
        <div class="headerPizarra">
            <div class="containerPizarra"> 
                <h1>Novedades</h1>
                <h2>Próximamente más información</h2>
            </div>
            <marcaEmpresarial :data="data"/>
        </div>
    </div>
</template>
  
<script>
import marcaEmpresarial from '@/views/marca_empresarial/pages/marca_empresarial_page.vue';

export default {
    name: "categories",
    components: {
        marcaEmpresarial
    },
    props: {
        data: {
            required: true
        },
    },
    computed: {
    },
    async mounted() {
    },
    methods: {
    },

};
</script>
  
<style lang="css" scoped>
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Amsi Pro',  sans-serif;
        color: #2D0049;
        font-weight: normal;
    }
    .pizarra {
        background-color: #fff6ef;
        border-radius: 10px;
    }
    .headerPizarra{
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 40px;
    }
    .containerPizarra{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 2vh;
    }
    
    @media screen and (max-width: 900px) {
        h1 {
        font-size: 3vh;
        }

        h2 {
        font-size: 2vh;
        }
    }

    @media screen and (max-width: 500px) {
        h1 {
        font-size: 3vh;
        }

        h2 {
        font-size: 2vh;
        }

        .headerPizarra{
            display: block;
        }

        .containerPizarra{
            gap: 2vh;
            padding: 2vh
        }
    }

</style>
  